import { OrderSummaryAction } from './orderSummary.types';
import { fetchOrderSummary as fetchOrderSummaryApi } from '../../services/purchaseApi';

export const fetchOrderSummary = async (dispatch: React.Dispatch<OrderSummaryAction>) => {
  try {
    const data = await fetchOrderSummaryApi();
    dispatch({
      type: 'SET_ORDER_SUMMARY',
      payload: data
    });
  } catch (err) {
    return Promise.reject(err instanceof Error ? err : new Error(String(err)));
  }
};
